<template>
  <div>

    <main role="main">

      <div class="container">

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="false"></loading>


        <div class="row">
          <div class="col-md-12">
            <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
              <i class="fa fa-chevron-circle-left"></i> {{$t('text.globals.back')}}
            </a>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mb-4">
            <h2 class="d-inline">
              {{ $t("text.premikanjeRazredov.premestitevRazredovZgradivom") }}
            </h2>
          </div>
        </div>

        <div class="row">

          <div class="col-md-12">

            <b-tabs content-class="mt-3 border-0" v-model="activeTab">
              <b-tab title="Premestitev razreda">

                <div class="row">
                  <div class="col-md-12 mb-4">
                    <div class="card">
                      <div class="card-body">
                        <h3>{{ $t("text.premikanjeRazredov.classesToMoveList") }}</h3>

                        <div v-if="moveListData && moveListData.length === 0">
                          <em><i class="fa fa-exclamation-triangle"></i>
                            {{ $t("text.premikanjeRazredov.noClassesChosenToMove") }}</em>
                        </div>

                        <div v-if="moveListData && moveListData.length > 0">

                          <b-row>
                            <b-col class="mt-4">


                              <div class="table-responsive">
                                <table class="table table-hover">
                                  <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>{{ $t("text.premikanjeRazredov.classToMove") }}</th>
                                    <th>{{ $t("text.premikanjeRazredov.newParentClass") }}</th>
                                    <th>{{ $t("text.premikanjeRazredov.classificationLabel") }}</th>
                                    <th>{{ $t("text.premikanjeRazredov.reason") }}</th>
                                    <th>{{ $t("text.premikanjeRazredov.expirationDateData") }}</th>
                                    <th style="width: 200px;">{{ $t("text.premikanjeRazredov.actions") }}</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(item, index) in moveListData">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.uuid }} <span
                                        class="badge badge-info">{{ getClassLabelForUuid(item.uuid) }}</span></td>
                                    <td>{{ item.parentUuid }} <span
                                        class="badge badge-info">{{ getClassLabelForUuid(item.parentUuid) }}</span></td>
                                    <td>{{ item.label }}</td>
                                    <td>{{ item.reason }}</td>
                                    <td>
                                      <div v-if="item.rokiHrambe === null">
                                        <em>{{ $t("text.premikanjeRazredov.noChangesToExpirationDate") }}</em></div>
                                      <div v-if="item.rokiHrambe !== null">
                                        {{ item.rokiHrambe }}
                                      </div>
                                    </td>
                                    <td>
                                      <a class="btn btn-sm btn-primary text-white"
                                         @click="editMoveListDataItem(index);"><i class="fa fa-edit"></i>
                                        {{ $t("text.premikanjeRazredov.edit") }}</a>
                                      <a class="btn btn-sm btn-danger text-white"
                                         @click="deleteMoveListDataItem(index);"><i class="fa fa-trash"></i>
                                        {{ $t("text.premikanjeRazredov.remove") }}</a>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col class="mt-4">
                              <a class="btn btn-primary text-white" @click="checkMove"><i
                                  class="fa fa-stopwatch"></i> {{ $t("text.premikanjeRazredov.checkMoveDetails") }}
                                {{ moveListData.length }})</a>
                            </b-col>
                          </b-row>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-lg-6 mb-4">
                    <h3 v-if="!inMoveListDataItemEditMode">{{ $t("text.premikanjeRazredov.addingMoveToList") }}</h3>
                    <h3 v-if="inMoveListDataItemEditMode">{{ $t("text.premikanjeRazredov.editMoveOnList") }}</h3>

                    <b-row>

                      <b-col>

                        <div class="form-group">
                          <label for="classToMove">{{ $t("text.premikanjeRazredov.chooseClassToMove") }}<small
                              v-if="classToMove"> (alfrescoId:
                            {{ getUuidForClassLabel(classToMove) }})</small>:</label>

                          <v-select
                              class="form-control"
                              :options="_getClassificationPlan"
                              v-model="classToMove"
                              :reduce="item => item.classificationLabel"
                              :filter-by="knSearchFilter"
                              label="classificationLabelName"
                              name="classToMove"
                              id="classToMove"
                              @input="updateClassName"
                          >
                            <span slot="no-options">{{ $t("text.globals.noOptions") }}</span>

                            <template slot="option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'"
                >({{ option.classificationLabel }})</span
                >
                              {{ option.classificationLabelName }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'"
                >({{ option.classificationLabel }})</span
                >
                              {{ option.classificationLabelName }}
                            </template>
                          </v-select>
                        </div>

                      </b-col>
                    </b-row>

                    <b-row>

                      <b-col>

                        <div class="form-group">
                          <label for="newParentClass">{{ $t("text.premikanjeRazredov.chooseNewParentClass") }}<small
                              v-if="newParentClass"> (alfrescoId:
                            {{ getUuidForClassLabel(newParentClass) }})</small>:</label>
                          <v-select
                              class="form-control"
                              :options="_getClassificationPlanWithRoot"
                              v-model="newParentClass"
                              :reduce="item => item.classificationLabel"
                              :filter-by="knSearchFilter"
                              label="classificationLabelName"
                              name="newParentClass"
                              id="newParentClass"
                          >
                            <span slot="no-options">{{ $t("text.globals.noOptions") }}</span>

                            <template slot="option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'"
                >({{ option.classificationLabel }})</span
                >
                              {{ option.classificationLabelName }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'"
                >({{ option.classificationLabel }})</span
                >
                              {{ option.classificationLabelName }}
                            </template>
                          </v-select>
                        </div>

                      </b-col>
                    </b-row>

                    <b-row>

                      <b-col>

                        <div class="form-group">
                          <label for="newClassLabel">{{ $t("text.premikanjeRazredov.enterNewLabelName") }}</label>

                          <input type="text" class="form-control" id="newClassLabel"
                                 name="newClassLabel"
                                 v-model="newClassLabel">

                        </div>

                      </b-col>
                    </b-row>

                    <b-row>

                      <b-col>

                        <div class="form-group">
                          <label for="moveReason">{{ $t("text.premikanjeRazredov.moveReason") }}</label>

                          <textarea class="form-control" id="moveReason"
                                    name="newClassLabel"
                                    v-model="reason"
                                    rows="5"
                          />

                          <p class="text-danger" v-if="showCommentRequiredMsg && reason === ''">
                            {{ $t("text.premikanjeRazredov.reasonIsRequiredAlt") }}</p>

                        </div>

                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col>

                        <b-button @click="rokiHrambeEditFormVisible = !rokiHrambeEditFormVisible" variant="secondary"
                                  size="sm"><i
                            class="fa fa-chevron-right"></i> {{ $t("text.premikanjeRazredov.expirationDateChange") }}
                        </b-button>
                        <b-collapse v-model="rokiHrambeEditFormVisible" id="collapse-1" class="mt-2">
                          <!--Rok hrambe-->
                          <!--expiration display table-->

                          <div class="form-group clearfix">

                            <table :class="'table table-striped table-hover'">
                              <thead>
                              <tr>
                                <th scope="col">
                                  {{ $t('text.classificationPlanMetadata.expiration') }}
                                </th>
                                <th scope="col">
                                  {{ $t('text.classificationPlanEntry.expiration.year') }}
                                </th>
                                <th scope="col">
                                  {{ $t('text.classificationPlanEntry.expiration.expirationType') }}
                                </th>
                                <th scope="col" class="actionsCell">
                                  {{ $t('text.globals.actions') }}
                                </th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr :class="''"
                                  v-for="(rokHrambe, index) in newClassificationPlanEntry.rokHrambe"
                                  :key="rokHrambe.id">
                                <td>
                                  {{ getRokHrambeReadableLabel(rokHrambe.expiration) }}
                                </td>
                                <td>{{ rokHrambe.year }}</td>
                                <td>
                                  {{ getVrstaGradivaReadableLabel(rokHrambe.expirationType) }}
                                </td>
                                <td class="actionsCell">
                                  <b-button
                                      :disabled="newClassificationPlanEntry.containsRecords"
                                      id="editButton1"
                                      @click="showEditExpirationModal($event, {index: index, item: rokHrambe})"
                                      class="btn-sm" variant="primary"><i
                                      class="fa fa-edit"></i>
                                    {{ $t('text.globals.edit') }}
                                  </b-button>
                                  <b-button
                                      :disabled="newClassificationPlanEntry.containsRecords"
                                      :id="'deleteButton1_' + index"
                                      @click="showDeleteExpirationModal($event, {index: index, item: rokHrambe})"
                                      class="btn-sm" variant="danger"><i
                                      class="fa fa-trash"></i>
                                    {{ $t('text.globals.delete') }}
                                  </b-button>
                                </td>
                              </tr>
                              <tr v-if="newClassificationPlanEntry.rokHrambe.length === 0">
                                <td colspan="5">
                                  <em>{{ $t('text.classificationPlanEntry.expiration.noExpirationsAdded') }}</em>
                                </td>
                              </tr>
                              </tbody>
                            </table>


                            <b-button :disabled="newClassificationPlanEntry.containsRecords"
                                      id="addExpirationDateButton1"
                                      class="float-right mr-0 mb-3 btn-sm" variant="success"
                                      @click="showAddExpirationModal()"><i
                                class="fa fa-plus-circle"></i>
                              {{ $t('text.classificationPlanEntry.expiration.addExpiration') }}
                            </b-button>

                          </div>
                        </b-collapse>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="mt-4">
                        <a class="btn btn-success text-white"
                           :class="(!classToMove || !newParentClass ||  newClassLabel === '') ? 'disabled' : ''"
                           @click="addToMoveList" v-if="!inMoveListDataItemEditMode"><i
                            class="fa fa-plus"></i> {{ $t("text.premikanjeRazredov.addMoveToList") }}</a>

                        <a class="btn btn-success text-white mt-2"
                           :class="(!classToMove || !newParentClass ||  newClassLabel === '') ? 'disabled' : ''"
                           @click="updateItemInMoveList" v-if="inMoveListDataItemEditMode">
                          <i class="fa fa-plus"></i> {{ $t("text.premikanjeRazredov.updateValues") }}
                        </a>

                        <a class="btn btn-secondary text-white mt-2" @click="cancelMoveItemEdit"
                           v-if="inMoveListDataItemEditMode">
                          <i class="fa fa-times"></i> {{ $t("text.premikanjeRazredov.cancelEditing") }}
                        </a>
                      </b-col>
                    </b-row>


                  </div>
                </div>

              </b-tab>
              <b-tab title="Urnik premeščanj">

                <FullCalendar
                    ref="fullCalendar"
                    defaultView="dayGridMonth"
                    :plugins="calendarPlugins"
                    :weekends="true"
                    :first-day="1"
                    :events="events"
                    :default-date="defaultDate"
                    :locale="$t('text.globals.datePickerLocale')"
                    :lang="$t('text.globals.datePickerLocale')"
                    :height="'auto'"
                    @dateClick="handleCalendarDateClick"
                    @eventClick="handleEventClick"
                    @datesRender="handleCalendarDatesRender"
                    @eventRender="handleEventRender"
                    @dayRender="handleCalendarDayRender"

                />
              </b-tab>
            </b-tabs>

          </div>

        </div>


      </div>

    </main>

    <b-modal
        centered
        size="lg"
        id="modal-class-move-details"
        :title="'Podrobnosti o premiku razreda'"
        ref="modal-class-move-details"
    >
      <b-container>
        <b-row>
          <b-col>

            <h4>{{ $t("text.premikanjeRazredov.changes") }}</h4>
            <dl class="row">
              <dt class="col-sm-5">{{ $t("text.premikanjeRazredov.numberOfNameChanges") }}</dt>
              <dd class="col-sm-7">{{ clickedEventData['totalRecordsChangedLabel'] }}</dd>
              <dt class="col-sm-5">{{ $t("text.premikanjeRazredov.numberOfExpirationDateChanges") }}</dt>
              <dd class="col-sm-7">{{ clickedEventData['totalRecordsChangedRokHrambe'] }}</dd>


              <template
                  v-if="clickedEventData['modifications'] && clickedEventData['modifications'][0]">
                <div class="card w-100 mb-2" v-for="(item, index) in clickedEventData['modifications']"
                     :key="'preview_' + index">
                  <div class="card-body">
                    <em class="text-muted mx-3 mb-1">Sprememba {{ index + 1 }}</em>

                    <dt class="col-sm-5">UUID:</dt>
                    <dd class="col-sm-7">{{ item['uuid'] }}</dd>
                    <dt class="col-sm-5" v-if="item['label'] && item['label']['before']">
                      {{ $t("text.premikanjeRazredov.labelBefore") }}
                    </dt>
                    <dd class="col-sm-7" v-if="item['label'] && item['label']['before']">
                      {{ item["label"]["before"] }}
                    </dd>
                    <dt class="col-sm-5" v-if="item['label'] && item['label']['after']">
                      {{ $t("text.premikanjeRazredov.labelAfter") }}
                    </dt>
                    <dd class="col-sm-7" v-if="item['label'] && item['label']['after']">
                      {{ item["label"]["after"] }}
                    </dd>
                    <dt class="col-sm-5" v-if="item['rokiHrambe'] && item['rokiHrambe']['before']">
                      {{ $t("text.premikanjeRazredov.expirationDateBefore") }}
                    </dt>
                    <dd class="col-sm-7" v-if="item['rokiHrambe'] && item['rokiHrambe']['before']">
                                       <span v-for="(item,index) in item['rokiHrambe']['before']">
                                           <div v-for="innerItem in Object.keys(item)">
                                               <small class="font-weight-bold">{{ innerItem }}:</small>
                                               <span
                                                   v-if="innerItem === 'rokHrambe'">{{ $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:rok_hrambe', item[innerItem]) }}</span>
                                               <span v-else>{{ item[innerItem] }}</span>
                                           </div>
                                           <hr v-if="item['rokiHrambe'] && item['rokiHrambe']['before'] && index < item['rokiHrambe']['before'].length-1"/>
                                       </span>
                    </dd>
                    <dt class="col-sm-5" v-if="item['rokiHrambe'] && item['rokiHrambe']['after']">
                      {{ $t("text.premikanjeRazredov.expirationDateAfter") }}
                    </dt>
                    <dd class="col-sm-7" v-if="item['rokiHrambe'] && item['rokiHrambe']['after']">
                                       <span v-for="(item,index) in item['rokiHrambe']['after']">
                                           <div v-for="innerItem in Object.keys(item)">
                                               <small class="font-weight-bold">{{ innerItem }}:</small>
                                               <span
                                                   v-if="innerItem === 'rokHrambe'">{{ $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:rok_hrambe', item[innerItem]) }}</span>
                                               <span v-else>{{ item[innerItem] }}</span>
                                           </div>
                                           <hr v-if="item['rokiHrambe'] && item['rokiHrambe']['after'] && index < item['rokiHrambe']['after'].length-1"/>
                                       </span>
                    </dd>
                    <dt class="col-sm-5" v-if="item['reason']">
                      {{ $t("text.premikanjeRazredov.reason") }}:
                    </dt>
                    <dd class="col-sm-7" v-if="item['reason']">{{ item["reason"] }}</dd>
                  </div>
                </div>

              </template>
            </dl>

            <h4>{{ $t("text.premikanjeRazredov.moveTimeEstimate") }}</h4>
            <dl class="row">
              <dt class="col-sm-5">{{ $t("text.premikanjeRazredov.durations") }}</dt>
              <dd class="col-sm-7">{{ moveTimeEstimate }}</dd>
            </dl>

            <h4>{{ $t("text.premikanjeRazredov.setTimeBeforeMove") }}</h4>
            <VueCtkDateTimePicker id="startTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                  formatted="DD.MM.YYYY, HH:mm"
                                  :label="$t('text.apmPages.chooseDate')"
                                  v-model="moveStartTime"
                                  :locale="$t('text.globals.datePickerLocale')"
                                  :button-now-translation="$t('text.globals.now')"
            />

          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100">
        <b-button id="closeBtnModalClassMoveDetails" variant="secondary" class="float-left"
                  @click="$bvModal.hide('modal-class-move-details'); clickedEventData = {};"><i
            class="fa fa-times"></i> {{ $t('text.globals.close') }}
        </b-button>
        <b-button id="confirmMoveClassBtn" variant="success" class="float-right mr-0" @click="confirmMove();"><i
            class="fa fa-check"></i>
          {{ $t("text.premikanjeRazredov.confirmForMove") }}
        </b-button>
      </div>
    </b-modal>


    <b-modal
        centered
        size="lg"
        id="modal-schedule-event"
        :title="'Podrobnosti dogodka'"
        ref="modal-schedule-event"
    >
      <b-container>
        <b-row>
          <b-col>


            <dl class="row" v-if="clickedEventData">
              <dt class="col-sm-5">ID:</dt>
              <dd class="col-sm-7">{{ clickedEventData['id'] }}</dd>
              <dt class="col-sm-5">{{ $t("text.premikanjeRazredov.status") }}</dt>
              <dd class="col-sm-7">
                               <span v-if="clickedEventData['status'] === 'DONE'" class="badge badge-success">
                                {{ translateStatus(clickedEventData['status']) }}
                               </span>
                <span v-if="clickedEventData['status'] === 'IN_PROGRESS'" class="badge badge-info">
                                {{ translateStatus(clickedEventData['status']) }}
                               </span>
                <span v-if="clickedEventData['status'] === 'PENDING'" class="badge badge-warning">
                                {{ translateStatus(clickedEventData['status']) }}
                               </span>
                <span v-if="clickedEventData['status'] === 'CANCELED'" class="badge badge-secondary">
                                {{ translateStatus(clickedEventData['status']) }}
                               </span>
                <span v-if="clickedEventData['status'] === 'ERROR'" class="badge badge-danger">
                                {{ translateStatus(clickedEventData['status']) }}
                               </span>
              </dd>
              <dt class="col-sm-5">{{ $t("text.premikanjeRazredov.author") }}</dt>
              <dd class="col-sm-7">{{ clickedEventData['createdBy'] }}</dd>
              <dt class="col-sm-5">{{ $t("text.premikanjeRazredov.created") }}</dt>
              <dd class="col-sm-7">{{ clickedEventData['creationDate'] }}</dd>
              <dt class="col-sm-5" v-if="clickedEventData['modifiedDate']">{{
                  $t("text.premikanjeRazredov.changed")
                }}
              </dt>
              <dd class="col-sm-7" v-if="clickedEventData['modifiedDate']">
                {{ clickedEventData['modifiedDate'] }}
              </dd>
              <dt class="col-sm-5">{{ $t("text.premikanjeRazredov.start") }}</dt>
              <dd class="col-sm-7">{{ clickedEventData['startDate'] }}</dd>
            </dl>
            <h4>Spremembe</h4>
            <dl class="row">
              <dt class="col-sm-5">{{ $t("text.premikanjeRazredov.numberOfNameChanges") }}</dt>
              <dd class="col-sm-7">{{ clickedEventData['totalRecordsChangedLabel'] }}</dd>
              <dt class="col-sm-5">{{ $t("text.premikanjeRazredov.numberOfExpirationDateChanges") }}</dt>
              <dd class="col-sm-7">{{ clickedEventData['totalRecordsChangedRokHrambe'] }}</dd>


              <div
                  class="row w-100 px-3 mb-2"
                  v-if="clickedEventData['modificationsJson'] && clickedEventData['modificationsJson'][0]"
                  v-for="(item, index) in clickedEventData['modificationsJson']" :key="'item_' + index">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <em class="text-muted mx-3 mb-1">Sprememba {{ index + 1 }}</em>
                      <dt class="col-sm-5">UUID:</dt>
                      <dd class="col-sm-7">{{ item['uuid'] }}</dd>
                      <dt class="col-sm-5" v-if="item['label'] && item['label']['before']">
                        {{ $t("text.premikanjeRazredov.labelBefore") }}
                      </dt>
                      <dd class="col-sm-7" v-if="item['label'] && item['label']['before']">
                        {{ item["label"]["before"] }}
                      </dd>
                      <dt class="col-sm-5" v-if="item['label'] && item['label']['after']">
                        {{ $t("text.premikanjeRazredov.labelAfter") }}
                      </dt>
                      <dd class="col-sm-7" v-if="item['label'] && item['label']['after']">{{ item["label"]["after"] }}
                      </dd>
                      <dt class="col-sm-5" v-if="item['reason']">{{ $t("text.premikanjeRazredov.reason") }}</dt>
                      <dd class="col-sm-7" v-if="item['reason']">{{ item["reason"] }}</dd>
                      <dt class="col-sm-5"
                          v-if="item['rokiHrambe'] && item['rokiHrambe']['before'] && item['rokiHrambe']['before'].length > 0">
                        {{ $t("text.premikanjeRazredov.expirationDateBefore") }}
                      </dt>
                      <dd class="col-sm-7"
                          v-if="item['rokiHrambe'] && item['rokiHrambe']['before'] && item['rokiHrambe']['before'].length > 0">
                                               <span v-for="(item,index) in item['rokiHrambe']['before']">
                                                   <div v-for="innerItem in Object.keys(item)">
                                                       <small class="font-weight-bold">{{ innerItem }}:</small>
                                                       <span
                                                           v-if="innerItem === 'rokHrambe'">{{ $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:rok_hrambe', item[innerItem]) }}</span>
                                                       <span v-else>{{ item[innerItem] }}</span>

                                                   </div>
                                                   <hr v-if="item['rokiHrambe'] && item['rokiHrambe']['before'] && index < item['rokiHrambe']['before'].length-1"/>
                                               </span>
                      </dd>
                      <dt class="col-sm-5"
                          v-if="item['rokiHrambe'] && item['rokiHrambe']['after'] && item['rokiHrambe']['after'].length > 0">
                        {{ $t("text.premikanjeRazredov.expirationDateAfter") }}
                      </dt>
                      <dd class="col-sm-7"
                          v-if="item['rokiHrambe'] && item['rokiHrambe']['after'] && item['rokiHrambe']['after'].length > 0">
                                               <span v-for="(item,index) in item['rokiHrambe']['after']">
                                                   <div v-for="innerItem in Object.keys(item)">
                                                       <small class="font-weight-bold">{{ innerItem }}:</small>
                                                       <span
                                                           v-if="innerItem === 'rokHrambe'">{{ $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:rok_hrambe', item[innerItem]) }}</span>
                                                       <span v-else>{{ item[innerItem] }}</span>
                                                   </div>
                                                   <hr v-if="item['rokiHrambe'] && item['rokiHrambe']['after'] && index < item['rokiHrambe']['after'].length-1"/>
                                               </span>
                      </dd>
                    </div>
                  </div>
                </div>
              </div>
            </dl>

            <div v-if="clickedEventData['result']">
              <h4>Rezultat</h4>
              <div class="alert alert-info">{{ clickedEventData['result'] }}</div>
            </div>

          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100">
        <b-button id="closeBtn" variant="secondary" class="float-left"
                  @click="$bvModal.hide('modal-schedule-event'); clickedEventData = {};"><i
            class="fa fa-times"></i> {{ $t('text.globals.close') }}
        </b-button>
        <b-button id="deleteEventBtn" variant="danger" class="float-right mr-0" @click="beforeDeleteEvent();"
                  v-if="clickedEventData['status'] === 'PENDING'"><i class="fa fa-trash"></i>
          {{ $t('text.globals.delete') }}
        </b-button>
      </div>
    </b-modal>

    <!-- EXPRATION MODALS -->

    <!-- add expiration modal -->
    <b-modal
        centered
        size="lg"
        id="modal-add-expiration"
        :title="$t('text.classificationPlanEntry.expirationModal.addExpiration.title')"
        :hide-header-close="true">
      <b-row>
        <b-col>
          <div>
            <div class="form-group">
              <label for="rokHrambe">{{ $t('text.classificationPlanMetadata.expiration') }}</label>
              <v-select
                  class="form-control"
                  v-model="newExpiration.expiration"
                  id="rokHrambe"
                  name="rokHrambe"
                  :options="rokHrambe"
                  label="explanation"
                  :reduce="item => item.type"
                  @input="validateField('expiration'); clearYear();"
              >
                <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
              </v-select>
            </div>


            <div v-if="newExpiration.expiration === 'OMEJENO'" class="form-group">

              <label for="omejenoNa">{{ $t('text.classificationPlanMetadata.expirationYears') }}</label>
              <input type="number" class="form-control" id="omejenoNa"
                     aria-describedby="omejenoNa"
                     v-model="newExpiration.year"
                     name="omejenoNa"
                     :class="{'is-invalid': newExpirationErrorsEntry.year.missing ||  newExpirationErrorsEntry.year.numericError}"
                     @input="validateField('year')"
              >
              <label class="let">let</label>
              <small class="text-danger" v-if="newExpirationErrorsEntry.year.missing">
                {{ $t('text.classificationPlanEntry.expirationModal.restrictedToMissingError') }}
              </small>
              <small class="text-danger" v-if="newExpirationErrorsEntry.year.numericError">
                {{ $t('text.classificationPlanEntry.expirationModal.restrictedToNumericError') }}
              </small>
            </div>
            <br>

            <div class="form-check">
              <input id="isGeneral" class="form-check-input" type="checkbox"
                     v-model="newExpiration.isGeneral" @input="clearExpirationType()">
              <label class="mb-4"
                     for="isGeneral">{{ $t('text.classificationPlanEntry.expirationModal.generalExpiration') }}</label>
            </div>

            <div v-if="newExpiration.isGeneral != true" class="form-group">

              <label
                  for="expirationType">{{ $t('text.classificationPlanEntry.expirationModal.expirationType') }}</label>
              <v-select
                  class="form-control"
                  v-model="newExpiration.expirationType"
                  id="expirationType"
                  name="expirationType"
                  label="description"
                  :reduce="item => item.id.toString()"
                  :options="vrstaGradiva"
                  :class="{'is-invalid': newExpirationErrorsEntry.expirationType}"
                  @input="validateField('expirationType'); checkForDuplicatesInArrayField('rokHrambe', 'add')"
              >
                <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
              </v-select>
              <small class="text-danger" v-if="newExpirationErrorsEntry.expirationType">
                {{ $t('text.classificationPlanEntry.expirationModal.expirationTypeError') }}
              </small>
            </div>

            <small class="text-danger" v-if="duplicateExpirationError">
              {{ $t('text.classificationPlanEntry.expirationModal.duplicateExpirationError1') }}{{ getVrstaGradivaReadableLabel(newExpiration.expirationType) }}{{ $t('text.classificationPlanEntry.expirationModal.duplicateExpirationError2') }}
            </small>
          </div>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-button id="cancelButton2" class="float-left"
                  @click="$bvModal.hide('modal-add-expiration')">
          {{ $t('text.globals.cancel') }}
        </b-button>
        <b-button id="addExpirationDateButton2" class="float-right mr-0" variant="primary"
                  @click="addExpiration();">
          {{ $t('text.classificationPlanEntry.expirationModal.addExpiration.addExpiration') }}
        </b-button>
      </div>
    </b-modal>


    <!-- edit expiration modal -->
    <b-modal
        centered
        size="lg"
        id="modal-edit-expiration"
        :title="$t('text.classificationPlanEntry.expirationModal.editExpiration.title')"
        :hide-header-close="true">
      <b-row>
        <b-col>
          <div>
            <div class="form-group">
              <label for="rokHrambe2">{{ $t('text.classificationPlanMetadata.expiration') }}</label>
              <v-select
                  class="form-control"
                  v-model="newExpiration.expiration"
                  id="rokHrambe2"
                  name="rokHrambe2"
                  :options="rokHrambe"
                  label="explanation"
                  :reduce="item => item.type"
                  :class="{'is-invalid':  newExpirationErrorsEntry.expiration}"
                  @input="validateField('expiration'); clearYear();"
              >
                <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
              </v-select>
              <small class="text-danger" v-if=" newExpirationErrorsEntry.expiration">
                {{ $t('text.classificationPlanEntry.expirationModal.expirationError') }}
              </small>
            </div>

            <!--Omejeno na (ce pri roku hrambe izberemo opcijo 'omejeno')-->
            <div v-if="newExpiration.expiration === 'OMEJENO'" class="form-group">

              <label for="omejenoNa2">{{ $t('text.classificationPlanEntry.expirationModal.restrictedTo') }}</label>
              <input type="text" style="display: inline-block" class="form-control"
                     id="omejenoNa2"
                     aria-describedby="omejenoNa2"
                     v-model="newExpiration.year"
                     name="omejenoNa2"
                     :class="{'is-invalid': newExpirationErrorsEntry.year.missing || newExpirationErrorsEntry.year.numericError}"
                     @input="validateField('year')"
              >
              <label
                  style="display: inline-block">{{ $t('text.classificationPlanEntry.expirationModal.years') }}</label>
              <small class="text-danger" v-if="newExpirationErrorsEntry.year.missing">
                {{ $t('text.classificationPlanEntry.expirationModal.restrictedToMissingError') }}
              </small>
              <small class="text-danger" v-if="newExpirationErrorsEntry.year.numericError">
                {{ $t('text.classificationPlanEntry.expirationModal.restrictedToNumericError') }}
              </small>
            </div>
            <br>

            <div class="form-check">
              <input id="isGeneral2" class="form-check-input" type="checkbox"
                     v-model="newExpiration.isGeneral" @input="clearExpirationType()">
              <label class="mb-4"
                     for="isGeneral2">{{ $t('text.classificationPlanEntry.expirationModal.generalExpiration') }}</label>
            </div>


            <div v-if="newExpiration.isGeneral != true" class="form-group">
              <label
                  for="expirationType2">{{ $t('text.classificationPlanEntry.expirationModal.expirationType') }}</label>
              <v-select
                  class="form-control"
                  v-model="newExpiration.expirationType"
                  id="expirationType2"
                  name="expirationType2"
                  label="description"
                  :reduce="item => item.id.toString()"
                  :options="vrstaGradiva"
                  :class="{'is-invalid': newExpirationErrorsEntry.expirationType}"
                  @input="validateField('expirationType', selectedRow.index); checkForDuplicatesInArrayField('rokHrambe', 'edit')"
              >
                <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>

              </v-select>
              <small class="text-danger" v-if="newExpirationErrorsEntry.expirationType">
                {{ $t('text.classificationPlanEntry.expirationModal.expirationTypeError') }}
              </small>
            </div>

            <small class="text-danger" v-if="duplicateExpirationError">
              {{ $t('text.classificationPlanEntry.expirationModal.duplicateExpirationError1') }}{{ newExpiration.expirationType }}{{ $t('text.classificationPlanEntry.expirationModal.duplicateExpirationError2') }}
            </small>
          </div>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-button id="cancelButton3" class="float-left" @click="$bvModal.hide('modal-edit-expiration')">
          {{ $t('text.globals.cancel') }}
        </b-button>
        <b-button id="saveExpirationDateButton3" class="float-right mr-0" variant="primary"
                  @click="editExpiration();">
          {{ $t('text.classificationPlanEntry.expirationModal.editExpiration.saveExpiration') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal
        centered
        size="lg"
        id="modal-generalExpiration-error"
        :title="$t('text.globals.error')"
    >
      <b-row class="bg-light p-4">
        <b-col class="my-1">
          {{ $t('text.classificationPlanEntry.generalExpirationErrorModal.content') }}
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-button id="previousButton4" class="float-right mr-0" @click="$bvModal.hide('modal-generalExpiration-error')">
          {{ $t('text.globals.back') }}
        </b-button>
      </div>
    </b-modal>


    <!--delete expiration modal -->
    <b-modal
        centered
        size="lg"
        id="modal-delete-expiration"
        :title="$t('text.classificationPlanEntry.expirationModal.deleteExpiration.title')"
        :hide-header-close="true"
    >
      <b-row>
        <b-col>
          <p v-if="selectedRow.item">
            {{ $t('text.classificationPlanEntry.expirationModal.deleteExpiration.content') }}
            {{ getRokHrambeReadableLabel(selectedRow.item.expiration) }} ? </p>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-button id="cancelButton4" class="float-left" @click="$bvModal.hide('modal-delete-expiration')">
          {{ $t('text.globals.cancel') }}
        </b-button>
        <b-button id="deleteButton4" class="float-right mr-0" variant="danger"
                  @click="deleteExpiration()">{{ $t('text.globals.delete') }}
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction';
import flatten from "flat";
import uuidv1 from "uuid/v1";
import swal from "sweetalert2";

export default {
  name: 'PremikanjeRazredov',
  components: {
    Loading,
    vSelect,
    FullCalendar
  },

  data() {
    return {
      isLoading: false,
      calendarPlugins: [dayGridPlugin, interactionPlugin],
      defaultDate: this.moment().format('YYYY-MM-DD'),
      events: [],
      clickedEventData: {},
      classToMove: null,
      newParentClass: null,
      newClassLabel: "",
      reason: "",
      allMetadataOptions: [],
      rokHrambe: [],
      vrstaGradiva: [],
      duplicateExpirationError: false,
      newClassificationPlanEntry: {
        rokHrambe: [],
        errors: {
          classificationLabelNameIllegalCharactersError: false,
          classificationLabelNameDuplicateError: false,
          classificationLabel: {
            missing: false,
            valueError: false
          },
          classificationLabelName: false,
          classificationLabelDescription: false,
          rokHrambe: {
            expirationErrors: false,
            generalExpirationError: false,
            expirationFields: [],
          }
        },
      },
      newExpiration: {
        expiration: null,
        year: null,
        expirationType: null,
        isGeneral: false
      },
      newExpirationErrorsEntry: {
        expiration: false,
        year: {
          missing: false,
          numericError: false,
        },
        expirationType: false
      },
      selectedRow: {
        index: null,
        item: null,
      },

      rokiHrambeEditFormVisible: false,
      inMoveListDataItemEditMode: false,
      moveListDataItemEditPosition: null,

      moveListData: [],
      moveTimeEstimate: null,
      moveStartTime: null,
      classificationPlan: null,
      activeTab: 2,
      showCommentRequiredMsg: false,
      knSearchFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.classificationLabel.toLowerCase().indexOf(temp) > -1 ||
            option.classificationLabelName.toLowerCase().indexOf(temp) > -1
      }

    };
  },

  computed: {
    _getClassificationPlan() {
      //return this.$store.getters.getClassificationPlan;
      const _this = this;

      if (_this.classificationPlan) return _this.classificationPlan;

      let flattenClassificationPlan = flatten(this.$store.getters.getClassificationPlan);
      let classificationPlanToReturn = [];

      // retrieve classificationLabel & classificationLabelName from flatenned classificationPlan
      _.map(flattenClassificationPlan, function (val, key, idx) {
        if (key.indexOf('classificationLabelName') > -1) {
          let index = 0;
          let objIndex = Object.keys(flattenClassificationPlan).indexOf(key);

          if ((Object.keys(flattenClassificationPlan)[objIndex - 2].indexOf('classificationLabel') > -1) && (typeof val === 'string')) {
            let item = {
              classificationLabelName: val,
              classificationLabel: flattenClassificationPlan[Object.keys(flattenClassificationPlan)[objIndex - 2]],
              alfrescoId: flattenClassificationPlan[Object.keys(flattenClassificationPlan)[objIndex - 3]]
            }
            classificationPlanToReturn.push(item);
          }
        }
      });

      _this.classificationPlan = classificationPlanToReturn;

      console.log("classificationPlanToReturn", classificationPlanToReturn);
      return classificationPlanToReturn;

    },
    _getClassificationPlanWithRoot() {
      let classificationPlan = _.cloneDeep(
          this.$store.getters.getClassificationPlan
      );

      classificationPlan.unshift({
        alfrescoId: null,
        classificationLabel: "none",
        containsRecords: false,
        classificationLabelName: "Korenski načrt",
        classificationLabelDescription: "Korenski načrt",
        duplicatedClassLabels: [],
        rokHrambe: [],
        vpisnik: [],
        povezaniSistemi: [],
        usageEndDate: null,
        creationDate: null,
        parentClass: null,
        item: [],
        errors: {},
        structure: {
          isOpen: true,
          checked: true,
          depth: 1,
          changed: false,
          match: false
        }
      });


      let flattenClassificationPlan = flatten(classificationPlan);
      let classificationPlanToReturn = [];

      // retrieve classificationLabel & classificationLabelName from flatenned classificationPlan
      _.map(flattenClassificationPlan, function (val, key, idx) {
        if (key.indexOf('classificationLabelName') > -1) {
          let index = 0;
          let objIndex = Object.keys(flattenClassificationPlan).indexOf(key);

          if ((Object.keys(flattenClassificationPlan)[objIndex - 2].indexOf('classificationLabel') > -1) && (typeof val === 'string')) {
            let item = {
              classificationLabelName: val,
              classificationLabel: flattenClassificationPlan[Object.keys(flattenClassificationPlan)[objIndex - 2]],
              alfrescoId: flattenClassificationPlan[Object.keys(flattenClassificationPlan)[objIndex - 3]]
            }
            classificationPlanToReturn.push(item);
          }
        }
      });

      console.log("classificationPlanToReturn", classificationPlanToReturn);
      return classificationPlanToReturn;
    },


  },

  mounted() {
    const _this = this;

    let p1 = _this.$store.dispatch("retrieveAllDropdownOptions");
    let p2 = _this.$store.dispatch("retrieveAllMetadataOptions");

    Promise.all([p1, p2]).then((values) => {
      _this.rokHrambe = _this.$store.getters.getStorageDateOptions;
      _this.vrstaGradiva = _this.$store.getters.getDocumentTypeOptions;
      _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
      _this.getEvents();
    });
  },

  methods: {
    getEvents() {
      const _this = this;

      _this.isLoading = true;
      _this.events = [];

      axios.get(config.rootEhramba + 'editClassificationPlan')
          .then((res) => {

            _.each(res.data, function (item) {

              let eventItem = {
                className: item.status.toLowerCase(),
                title: item.id + ' - ' + _this.translateStatus(item.status),
                date: _this.moment(item.startDate).format('YYYY-MM-DD'),
                data: item
              };

              eventItem.data.modificationsJson = JSON.parse(item.modificationsJson);

              _this.events.push(eventItem);
            });

            _this.isLoading = false;


          })
          .catch((error) => {
            console.log("error", error);
            _this.isLoading = false;
            return false
          });

    },

    handleCalendarDateClick(info) {
      console.log("handleCalendarDateClick", info);
    },
    handleEventClick(info) {
      console.log("handleEventClick", info);
      const _this = this;

      _this.clickedEventData = info.event._def.extendedProps.data;
      _this.$bvModal.show('modal-schedule-event')
    },
    handleCalendarDatesRender(info) {
      // console.log("handleCalendarDatesRender", info);
    },
    handleEventRender(info) {
      if (info.event.extendedProps.data.result) {
        info.el.firstChild.innerHTML = info.el.firstChild.innerHTML + ' <i class="fa fa-exclamation-circle mt-1 text-info d-block float-right"></i><div class="clearfix"></div>';
      }
    },
    handleCalendarDayRender(info) {
      // console.log("handleCalendarDayRender", info);
    },
    beforeDeleteEvent() {
      const _this = this;

      this.$swal({
        title: this.$t('text.globals.warningTitle'),
        text: this.$t('text.premikanjeRazredov.deleteConfirmation') + " " + _this.clickedEventData.id + "?",
        dangerMode: true,
        buttons: {
          cancel: {
            text: this.$t('text.globals.cancel'),
            value: null,
            visible: true,
            className: "",
            closeModal: true,
          },
          confirm: {
            text: this.$t('text.globals.delete'),
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        },
      })
          .then((value) => {

            switch (value) {

              case true:
                _this.$bvModal.hide('modal-schedule-event');
                _this.deleteEvent();

              case null:

                return;

                break;

              default:

            }
          });

    },

    deleteEvent() {
      const _this = this;

      _this.isLoading = true;

      axios.delete(config.rootEhramba + 'editClassificationPlan?id=' + _this.clickedEventData.id)
          .then((res) => {
            console.log("DOGODEK IZBRISAN");
            _this.clickedEventData = {};
            _this.isLoading = false;
            _this.getEvents();
          })
          .catch((error) => {
            _this.isLoading = false;
            console.error(error);
          });
    },

    updateClassName() {
      const _this = this;
      _this.newClassLabel = _this.classToMove;
    },

    showAddExpirationModal() {
      this.$bvModal.show('modal-add-expiration');
    },

    addExpiration() {

      // before we add an expiration entry, we need to validate the expiration entry that we want to add and check all of the entries for general expiration errors
      if (this.validateArrayField("rokHrambe")) {


        if (this.validateForGeneralExpirationErrors(true) && this.checkForDuplicatesInArrayField("rokHrambe", "add")) {

          // if both validations go through, we can add a new expiration entry
          // ( we can't add a new class if it causes a general expiration error -- we can edit and delete them that way, that is why we pass true to the validation function - so the validation function knows that we are adding a new entry and returns false and doesn't update the error fields if we encounter a general expiration error )
          this.newClassificationPlanEntry.rokHrambe.push(this.newExpiration);
          this.newClassificationPlanEntry.errors.rokHrambe.expirationFields.push(this.newExpirationErrorsEntry);

          this.newExpiration = {expiration: null, expirationType: null, year: null, isGeneral: false};
          this.newExpirationErrorsEntry = {
            expiration: false,
            year: {missing: false, numericError: false},
            expirationType: false
          };
          this.duplicateExpirationError = false;
          this.$bvModal.hide('modal-add-expiration');
        } else if (!this.validateForGeneralExpirationErrors(true)) {
          this.$bvModal.show('modal-generalExpiration-error');
        }
      }
    },

    // validate a string type field in the form
    validateField(fieldName) {

      // classification label has an error object with an attributes missing and valueError to set errors
      if (fieldName === "classificationLabel") {

        this.newClassificationPlanEntry.errors.classificationLabel.missing = (this.newClassificationPlanEntry.classificationLabel == null || this.newClassificationPlanEntry.classificationLabel === "");

        return !this.newClassificationPlanEntry.errors.classificationLabel.missing;

      }
      // for expiration we just check if there is one
      else if (fieldName === "expiration") {

        this.newExpirationErrorsEntry.expiration = (this.newExpiration.expiration == null || this.newExpiration.expiration === "");
        return !this.newExpirationErrorsEntry.expiration;

      }
      // if expiration is  set to "OMEJENO" we also need to validate the year variable, otherwise not
      else if (fieldName === "year") {

        if (this.newExpiration.expiration === "OMEJENO") {

          this.newExpirationErrorsEntry.year.missing = (this.newExpiration.year == null || this.newExpiration.year === "");
          this.newExpirationErrorsEntry.year.numericError = isNaN(this.newExpiration.year) || !this.newExpiration.year.match(/^[1-9]\d*$/);
        } else {

          this.newExpirationErrorsEntry.year.missing = false;
          this.newExpirationErrorsEntry.year.numericError = false;

        }

        return !(this.newExpirationErrorsEntry.year.missing || this.newExpirationErrorsEntry.year.numericError);

      }
      // if the expiration is general, we dont validate expirationType, otherwise we do
      else if (fieldName === "expirationType") {

        if (this.newExpiration.isGeneral) {

          this.newExpirationErrorsEntry.expirationType = false;
        } else {

          this.newExpirationErrorsEntry.expirationType = (this.newExpiration.expirationType == null || this.newExpiration.expirationType === "");

        }

        return !this.newExpirationErrorsEntry.expirationType;
      }
      // in general we check if the field exists and save the potential error to the error object
      else {

        this.newClassificationPlanEntry.errors[fieldName] = (this.newClassificationPlanEntry[fieldName] == null || this.newClassificationPlanEntry[fieldName] === "");

        return !this.newClassificationPlanEntry.errors[fieldName];
      }


    },

    // validate the expiration field for general expiration errors
    validateForGeneralExpirationErrors(addMode) {

      let generalExpirationNumber = 0;


      // we iterate through all of the existing expiration entries and also the new one that we want to add and count the number of general expirations
      for (let i = 0; i < this.newClassificationPlanEntry.rokHrambe.length; i++) {

        if (this.newClassificationPlanEntry.rokHrambe[i].isGeneral) {

          generalExpirationNumber++;
        }

      }

      if (this.newExpiration.isGeneral) {

        generalExpirationNumber++;
      }


      // if there is one general expiration, we set the generalExpirationError to false and return true (no errors)
      if (generalExpirationNumber === 1) {


        this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = false;


        return true;

      }
      // if there is no general expirations and we want to add an expiration that is not a general one (addMode !), we return true (no errors), so the validation goes through when adding, but we set the  generalExpirationError to true (so we display that we need to add a general expiration)
      else if (generalExpirationNumber === 0) {

        if (addMode) {

          this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = true;

          return true;

        } else {

          this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = true;

          return false;

        }

      }
          // if we want to add a general expiration but there is already one added, we return false (error) so the validation doesn't go through when adding and we also dont' set the generalExpirationError, because the class won't be added,
      // --- if we are not in adding , we let the user to make general expiration errors, so we set the generalExpirationError to true - the functions for editig and deleting let the user through
      else {

        if (addMode) {

          return false;
        } else {

          this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = true;

          return false;
        }


      }

    },


    validateUsageEndDate() {

      if (this.showCollapseClose) {
        this.usageEndDateErrors = (this.newClassificationPlanEntry.usageEndDate == null || this.newClassificationPlanEntry.usageEndDate === "");
        return !this.usageEndDateErrors;
      } else {
        return true;
      }

    },

    // validate an array type field in the form
    validateArrayField(fieldName) {

      if (fieldName === "povezaniSistemi" || fieldName === "vpisnik") {

        // if the field is connected systems, we set an error if we have an empty field
        if (fieldName === "povezaniSistemi") {

          this.newConnectedSystemErrors = (this.newConnectedSystem === "" || this.newConnectedSystem == null);

          return !this.newConnectedSystemErrors;

        }
        // if the field is registry, we set an error if we have an empty field
        else if (fieldName === "vpisnik") {

          this.newRegistryErrors = (this.newRegistry == null || this.newRegistry.length === 0 || this.newRegistry === "");

          return !this.newRegistryErrors;
        }

      }
      // if the field is epiration, we check all the fields in the new expiration entry and set the errors
      else if (fieldName === "rokHrambe") {

        let rokHrambeEntryError = true;

        for (let key of Object.keys(this.newExpirationErrorsEntry)) {

          if (!this.validateField(key)) {
            rokHrambeEntryError = false;
          }
        }

        return rokHrambeEntryError;
      }

    },

    // clearing hidden fields


    clearExpirationType() {

      if (this.newExpiration.isGeneral) {

        this.newExpiration.expirationType = null;
        this.newExpirationErrorsEntry.expirationType = false;
        this.duplicateExpirationError = false;
      }

    },

    clearYear() {

      if ((this.previouslySelectedExpiration === 'OMEJENO' || this.previouslySelectedExpiration == null) && this.newExpiration.expiration !== 'OMEJENO') {
        this.newExpiration.year = null;
        this.newExpirationErrorsEntry.year.numericError = false;
        this.newExpirationErrorsEntry.year.missing = false;
      }

      this.previouslySelectedExpiration = this.newExpiration.expiration;

    },

    checkForDuplicatesInArrayField(fieldType, mode) {

      if (fieldType === "povezaniSistemi") {

        // če je mode edit preverimo, če je selected row.index enak trenutnemu in spustimo čez, če je

        for (let i = 0; i < this.newClassificationPlanEntry.povezaniSistemi.length; i++) {
          if (this.newClassificationPlanEntry.povezaniSistemi[i] === this.newConnectedSystem) {
            if (mode === "edit") {
              if (this.selectedRow.index === i) {
                this.duplicateConnectedSystemsError = false;
                return true;
              } else {
                this.duplicateConnectedSystemsError = true;
                return false;
              }

            } else if (mode === "add") {

              this.duplicateConnectedSystemsError = true;
              return false;


            }
          }

        }
        this.duplicateConnectedSystemsError = false;
        return true;


      } else if (fieldType === "vpisnik") {
        if (mode === "edit") {

          for (let i = 0; i < this.newClassificationPlanEntry.vpisnik.length; i++) {
            if (this.newClassificationPlanEntry.vpisnik[i] === this.newRegistry) {

              if (this.selectedRow.index === i) {
                this.duplicateRegistryError = false;
                return true;
              } else {
                this.duplicateRegistryError = true;
                return false;
              }


            }
          }
          this.duplicateRegistryError = false;
          return true;

        } else if (mode === "add") {

          this.newRegistryDuplicatesList = [];
          this.duplicateRegistryError = false;

          for (let i = 0; i < this.newRegistry.length; i++) {

            if (this.newClassificationPlanEntry.vpisnik.includes(this.newRegistry[i])) {

              this.newRegistryDuplicatesList.push(this.newRegistry[i]);
              this.duplicateRegistryError = true;
            }


          }

          if (this.duplicateRegistryError) {
            return false;
          } else {
            return true;
          }

        }
      } else if (fieldType === "rokHrambe") {

        for (let i = 0; i < this.newClassificationPlanEntry.rokHrambe.length; i++) {
          if (this.newClassificationPlanEntry.rokHrambe[i].expirationType === this.newExpiration.expirationType) {
            if (mode === "edit") {
              if (this.selectedRow.index === i) {
                this.duplicateExpirationError = false;
                return true;
              } else {
                this.duplicateExpirationError = true;
                return false;
              }

            } else if (mode === "add") {

              this.duplicateExpirationError = true;
              return false;


            }
          }
        }
        this.duplicateExpirationError = false;
        return true;
      }


    },

    getRokHrambeReadableLabel(rokHrambeType) {

      if (rokHrambeType == null) {
        return null;
      } else {

        for (let i = 0; i < this.rokHrambe.length; i++) {
          if (this.rokHrambe[i].type.toString() === rokHrambeType.toString()) {
            return this.rokHrambe[i].explanation;
          }

        }

        return null;
      }

    },

    getVrstaGradivaReadableLabel(vrstaGradivaId) {


      if (vrstaGradivaId == null) {

        return null;
      } else {
        const _this = this;


        for (let i = 0; i < this.vrstaGradiva.length; i++) {

          if (this.vrstaGradiva[i].id.toString() === vrstaGradivaId.toString()) {


            return this.vrstaGradiva[i].description;
          }


        }

        return null;
      }

    },

    //edit expiration functions
    showEditExpirationModal($event, row) {

      this.selectedRow = row;
      this.newExpiration = _.cloneDeep(this.newClassificationPlanEntry.rokHrambe[row.index]);
      this.newExpirationErrorsEntry = _.cloneDeep(this.newClassificationPlanEntry.errors.rokHrambe.expirationFields[row.index]);

      this.$bvModal.show('modal-edit-expiration');
    },

    closeEditExpirationModal() {

      this.newExpiration = {expiration: null, expirationType: null, year: null, isGeneral: false};
      this.newExpirationErrorsEntry = {
        expiration: false,
        year: {missing: false, numericError: false},
        expirationType: false
      };
      this.duplicateExpirationError = false;
      this.$bvModal.hide('modal-edit-expiration');
    },

    editExpiration() {

      // before we save the edited expiration entry, we need to validate the expiration entry that we have edited
      if (this.validateArrayField("rokHrambe") && this.checkForDuplicatesInArrayField("rokHrambe", "edit")) {


        this.newClassificationPlanEntry.rokHrambe[this.selectedRow.index] = this.newExpiration;
        this.newClassificationPlanEntry.errors.rokHrambe.expirationFields[this.selectedRow.index] = this.newExpirationErrorsEntry;

        this.newExpiration = {expiration: null, expirationType: null, year: null, isGeneral: false};
        this.newExpirationErrorsEntry = {
          expiration: false,
          year: {missing: false, numericError: false},
          expirationType: false
        };
        this.duplicateExpirationError = false;
        // here we pass false to the validateForGeneralExpirationErrors() function -- that way the function just updates the fields for general expiration errors, because we just want to show the error when editing or deleting expiration entries
        this.validateForGeneralExpirationErrors(false);

        this.$bvModal.hide('modal-edit-expiration');

      }

    },

    //delete expiration functions

    showDeleteExpirationModal($event, row) {

      this.selectedRow = row;
      this.$bvModal.show('modal-delete-expiration');
    },

    closeDeleteExpirationModal() {

      this.$bvModal.hide('modal-delete-expiration');
    },

    deleteExpiration() {

      this.newClassificationPlanEntry.rokHrambe.splice(this.selectedRow.index, 1);
      this.newClassificationPlanEntry.errors.rokHrambe.expirationFields.splice(this.selectedRow.index, 1);

      this.validateForGeneralExpirationErrors(false);

      this.$bvModal.hide('modal-delete-expiration');
    },

    getUuidForClassLabel(classLabel) {
      const _this = this;

      let classificationPlan = _this.classificationPlan;

      // console.log(classLabel);
      // console.log(_.find(classificationPlan, {classificationLabel: classLabel}));

      if (classLabel === 'none') {
        return '-filePlan-'
      } else if (_.find(classificationPlan, {classificationLabel: classLabel})) {
        return _.find(classificationPlan, {classificationLabel: classLabel}).alfrescoId
      }
    },

    getClassLabelForUuid(uuid) {
      const _this = this;

      let classificationPlan = _this.classificationPlan;

      console.log(uuid);
      console.log(classificationPlan);
      console.log(_.find(classificationPlan, {alfrescoId: uuid}));

      if (uuid === '-filePlan-') {
        return 'none'
      } else if (_.find(classificationPlan, {alfrescoId: uuid})) {
        return _.find(classificationPlan, {alfrescoId: uuid}).classificationLabel
      }
    },

    addToMoveList() {
      const _this = this;

      let rokiHrambe = [];

      if (_this.reason === "") {
        // swal(this.$t('text.globals.error'), this.$t('text.premikanjeRazredov.reasonIsRequired'), "error", {dangerMode: true});
        _this.showCommentRequiredMsg = true;
        return;
      }

      _.each(_this.newClassificationPlanEntry.rokHrambe, function (item) {
        console.log("item", item);

        let rokHrambeType = null;

        if (item.expiration === 'OMEJENO') {
          rokHrambeType = 5;
        } else if (item.expiration === 'A') {
          rokHrambeType = 1;
        } else if (item.expiration === 'T') {
          rokHrambeType = 2;
        }

        rokiHrambe.push(
            {
              rokHrambe: rokHrambeType,
              years: item.year ? parseInt(item.year) : null,
              general: item.isGeneral,
              documentType: item.expirationType
            }
        )
      });

      let moveData = {
        uuid: _this.getUuidForClassLabel(_this.classToMove),
        parentUuid: _this.getUuidForClassLabel(_this.newParentClass),
        label: _this.newClassLabel,
        reason: _this.reason,
        rokiHrambe: rokiHrambe.length > 0 ? rokiHrambe : null
      };

      _this.moveListData.push(moveData);

      _this.classToMove = null;
      _this.showCommentRequiredMsg = false;
      _this.newParentClass = null;
      _this.newClassLabel = "";
      _this.reason = "";
      _this.newClassificationPlanEntry.rokHrambe = [];
      _this.rokiHrambeEditFormVisible = false;
    },

    updateItemInMoveList() {
      const _this = this;

      let rokiHrambe = [];

      _.each(_this.newClassificationPlanEntry.rokHrambe, function (item) {
        console.log("item", item);

        let rokHrambeType = null;

        if (item.expiration === 'OMEJENO') {
          rokHrambeType = 5;
        } else if (item.expiration === 'A') {
          rokHrambeType = 1;
        } else if (item.expiration === 'T') {
          rokHrambeType = 2;
        }

        rokiHrambe.push(
            {
              rokHrambe: rokHrambeType,
              years: item.year ? parseInt(item.year) : null,
              general: item.isGeneral,
              documentType: item.expirationType
            }
        )
      });

      let moveData = {
        uuid: _this.getUuidForClassLabel(_this.classToMove),
        parentUuid: _this.getUuidForClassLabel(_this.newParentClass),
        label: _this.newClassLabel,
        reason: _this.reason,
        rokiHrambe: rokiHrambe.length > 0 ? rokiHrambe : null
      };

      _this.moveListData[_this.moveListDataItemEditPosition] = moveData;

      _this.classToMove = null;
      _this.newParentClass = null;
      _this.newClassLabel = "";
      _this.reason = "";
      _this.showCommentRequiredMsg = false;
      _this.newClassificationPlanEntry.rokHrambe = [];
      _this.rokiHrambeEditFormVisible = false;

      _this.inMoveListDataItemEditMode = false;
      _this.moveListDataItemEditPosition = null;

    },

    editMoveListDataItem(arrIndex) {
      const _this = this;

      if (_this.inMoveListDataItemEditMode) {
        _this.$swal({
          title: "Urejanje premika v teku!",
          text: "Če želite urediti nov premik, zaključite oz. prekličite trenutno urejanje premika.",
          icon: 'warning',
          dangerMode: true,
        });
        return
      }

      _this.inMoveListDataItemEditMode = true;
      _this.moveListDataItemEditPosition = arrIndex;

      let item = _this.moveListData[arrIndex];

      _this.classToMove = _this.getClassLabelForUuid(item.uuid);
      _this.newParentClass = _this.getClassLabelForUuid(item.parentUuid);
      _this.newClassLabel = item.label;
      _this.reason = item.reason;

      console.log("edit item:", item);
      if (item.rokiHrambe !== null) {

        let rokiHrambe = [];

        _.each(item.rokiHrambe, function (_item) {
          console.log("_item", _item);

          let rokHrambeType = null;

          if (_item.rokHrambe === 5) {
            rokHrambeType = 'OMEJENO';
          } else if (_item.rokHrambe === 1) {
            rokHrambeType = 'A';
          } else if (_item.rokHrambe === 2) {
            rokHrambeType = 'T';
          }

          rokiHrambe.push(
              {
                expiration: rokHrambeType,
                year: _item.years,
                isGeneral: _item.general,
                expirationType: _item.documentType
              }
          )

        });

        _this.newClassificationPlanEntry.rokHrambe = rokiHrambe;

      }
      //_this.newClassificationPlanEntry.rokHrambe = item.rokiHrambe;

      _this.rokiHrambeEditFormVisible = true;

    },

    deleteMoveListDataItem(arrIndex) {
      const _this = this;

      if (_this.inMoveListDataItemEditMode) {
        _this.$swal({
          title: "Urejanje premika v teku!",
          text: "Če želite odstraniti premik, zaključite oz. prekličite trenutno urejanje premika.",
          icon: 'warning',
          dangerMode: true,
        });
        return
      }

      _this.moveListData.splice(arrIndex, 1);
    },

    cancelMoveItemEdit() {
      const _this = this;

      _this.inMoveListDataItemEditMode = false;
      _this.moveListDataItemEditPosition = null;

      _this.classToMove = null;
      _this.newParentClass = null;
      _this.newClassLabel = "";
      _this.rokHrambe = [];
      _this.newClassificationPlanEntry.rokHrambe = [];

    },

    checkMove() {
      const _this = this;

      _this.isLoading = true;

      _this.moveData = {
        checkOnly: true,
        items: _this.moveListData
      };

      axios.post(config.rootEhramba + 'editClassificationPlan', _this.moveData)
          .then((res) => {
            console.log("DOGODEK: ", res.data);
            _this.isLoading = false;
            _this.clickedEventData = res.data;
            //_this.moveTimeEstimate = _this.secondsToString(Math.max(res.data.totalRecordsChangedLabel, res.data.totalRecordsChangedRokHrambe) * 3);

            let cas_labele = res.data.totalRecordsChangedLabel * 0.017;
            let cas_roki = 0;

            if (res.data.totalRecordsChangedRokHrambe >= 10000) {
              cas_roki = res.data.totalRecordsChangedRokHrambe * res.data.totalRecordsChangedRokHrambe * 0.000001 + res.data.totalRecordsChangedRokHrambe * 0.006
            } else {
              cas_roki = 0.017 * res.data.totalRecordsChangedRokHrambe - 15
              if (cas_roki < 0) {
                cas_roki = 0
              }
            }

            console.log("trajanje v minutah: ", cas_roki + cas_labele);
            _this.moveTimeEstimate = _this.secondsToString((cas_roki + cas_labele) * 60);
            _this.$bvModal.show('modal-class-move-details');
          })
          .catch((error) => {
            _this.isLoading = false;
            console.error(error);
          });

    },

    confirmMove() {
      const _this = this;
      _this.isLoading = true;

      if (!_this.moveStartTime) {
        _this.$swal({
          title: "Čas začetka izvajanja premika ni določen!",
          text: "Za oddajo zahtevka za premestitev je potrebno določiti čas začetka.",
          icon: 'warning',
          dangerMode: true,
        });
        return;
      }

      _this.moveData = {
        checkOnly: false,
        items: _this.moveListData,
        startDate: _this.moveStartTime
      };

      axios.post(config.rootEhramba + 'editClassificationPlan', _this.moveData)
          .then((res) => {
            console.log("DOGODEK: ", res.data);
            _this.isLoading = false;
            _this.$bvModal.hide('modal-class-move-details');
            _this.clickedEventData = {};
            _this.moveTimeEstimate = null;
            _this.moveData = null;
            _this.classToMove = null;
            _this.newParentClass = null;
            _this.newClassLabel = "";
            _this.newClassificationPlanEntry.rokHrambe = [];
            _this.rokiHrambeEditFormVisible = false;
            _this.moveListData = [];

            _this.getEvents();
            _this.activeTab = 2;
            _this.$forceUpdate();
          })
          .catch((error) => {
            _this.isLoading = false;
            console.error(error);
          });


    },

    secondsToString(seconds) {
      let numyears = Math.floor(seconds / 31536000);
      let numdays = Math.floor((seconds % 31536000) / 86400);
      let numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
      let numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
      let numseconds = (((seconds % 31536000) % 86400) % 3600) % 60;
      return (numyears > 0 ? numyears + " let " : '') + (numdays > 0 ? numdays + " dni " : '') + (numhours > 0 ? numhours + " ur " : '') + (numminutes > 0 ? numminutes + " minut " : '') + Math.round(numseconds) + " sekund";

    },

    translateStatus(status) {

      let translatedStatus = status;

      switch (status) {
        case "DONE":
          translatedStatus = "zaključeno";
          break;
        case "IN_PROGRESS":
          translatedStatus = "v teku";
          break;
        case "PENDING":
          translatedStatus = "v čakanju";
          break;
        case "CANCELED":
          translatedStatus = "preklicano";
          break;
        case "ERROR":
          translatedStatus = "napaka";
          break;
      }

      return translatedStatus;

    }

  }
};
</script>



// WEBPACK FOOTER //
// src/pages/PremikanjeRazredov.vue